// TypeScript version of the Reward system

export enum RewardType {
    NONE = 0,
    GC = 1,
    SC = 2,
}

export enum RewardSource {
    //添加桌面奖励
    AddDesktop = 101,
    //游戏等级升级
    GAME_LEVEL_UP = 102,
    //VIP等级升级
    VIP_LEVEL_UP = 103,
}

export enum RewardOption {
    Display = 0,
    Get,
    Cost,
}

export class SRewardData {
    scAvailableToRedeemAtom: number = 0; // Redeemable SC
    scUnPlayedBalanceAtom: number = 0;  // Reward SC
    gcAmount: number = 0;              // GC
    get scAmountAtom(): number {
        return this.scAvailableToRedeemAtom + this.scUnPlayedBalanceAtom;
    }
}

export interface SRewardHistoryData {
    spinCostGc: number;           // Historical GC consumption
    spinCostSc: number;           // Historical SC consumption (excluding redemption)
    recharge: number;             // Historical recharge
    redeemSc: number;             // Historical redemption, including pending redemption
    redeemCount: number;          // Total redemption attempts (including pending)
    redeemSuccessCount: number;   // Successful redemption count
    redeemSuccessfulSc: number;   // Total successful redemption amount
    totalDisputeAmount: number;   // Total disputed amount
}

export class RewardConfig {
    static getIconUrl(rewardType: RewardType): string {
        switch (rewardType) {
            case RewardType.GC:
                return "ui://Common/ico_jb";
            case RewardType.SC:
                return "ui://Common/ico_qb";
            default:
                console.error(`Unknown RewardType: ${rewardType}`);
                return "";
        }
    }
}

export class Reward {
    gc: number = 0;       // GC amount
    sc: number = 0;       // SC amount
    scRewardCnt: number = 0; // Number of SC rewards

    get isEmpty(): boolean {
        return this.gc <= 0 && this.sc <= 0;
    }
    toString(): string {
        return `gc: ${this.gc}, sc: ${this.sc}`;
    }
}
